import type React from 'react';

import { Pagination as PaginationComponent } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePaginationComponent } from './hooks/usePagination';

export const Pagination: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { currentPage, totalPages, shouldHidePagination },
		actions: { setPage },
	} = usePaginationComponent();

	if (shouldHidePagination) {
		return null;
	}

	return (
		<div className="flex justify-center overflow-hidden py-10">
			<PaginationComponent
				currentPage={currentPage + 1}
				nextLabel={translate('corgi.components.pagination.next')}
				onPageChange={setPage}
				prevLabel={translate('corgi.components.pagination.previous')}
				totalPages={totalPages}
			/>
		</div>
	);
};
